<template>
	<div id="App">
        <div v-if="entryUrl=='/bcs'">
            <object :data="require('@/assets/'+$i18n.locale+'/北京通州华仁学校/pc.svg')" class="app_img pc"></object>
            <object :data="require('@/assets/'+$i18n.locale+'/北京通州华仁学校/wap.svg')" class="app_img wap"></object>
        </div>
        <div v-if="entryUrl=='/bccsc'">
            <object :data="require('@/assets/'+$i18n.locale+'/北京中加学校/pc.svg')" class="app_img pc"></object>
            <object :data="require('@/assets/'+$i18n.locale+'/北京中加学校/wap.svg')" class="app_img wap"></object>
        </div>
        <div v-if="entryUrl=='/elementaryschool'">
            <object :data="require('@/assets/'+$i18n.locale+'/小学/pc.svg')" class="app_img pc"></object>
            <object :data="require('@/assets/'+$i18n.locale+'/小学/wap.svg')" class="app_img wap"></object>
        </div>
        <div v-if="entryUrl=='/middleschool'">
            <object :data="require('@/assets/'+$i18n.locale+'/初中/pc.svg')" class="app_img pc"></object>
            <object :data="require('@/assets/'+$i18n.locale+'/初中/wap.svg')" class="app_img wap"></object>
        </div>
        <div v-if="entryUrl=='/highschool'">
            <object :data="require('@/assets/'+$i18n.locale+'/国际高中/pc.svg')" class="app_img pc"></object>
            <object :data="require('@/assets/'+$i18n.locale+'/国际高中/wap.svg')" class="app_img wap"></object>
        </div>
        <div v-if="entryUrl=='/gwacademy'">
            <object :data="require('@/assets/'+$i18n.locale+'/长城书院/pc.svg')" class="app_img pc"></object>
            <object :data="require('@/assets/'+$i18n.locale+'/长城书院/wap.svg')" class="app_img wap"></object>
        </div>
        <div v-if="entryUrl=='/studyinChina'">
            <object :data="require('@/assets/'+$i18n.locale+'/来华/pc.svg')" class="app_img pc"></object>
            <object :data="require('@/assets/'+$i18n.locale+'/来华/wap.svg')" class="app_img wap"></object>
        </div>
		<router-view ref="child" :class="$i18n.locale" />
	</div>
</template>
<script>
import { mapState } from 'vuex';
export default {
	name: 'App',
    data(){
        return{
        }
    },
    computed: {
        ...mapState(['entryAnimation','entryUrl'])
    },
}
</script>
<style>
.entryAnimation-enter{
    transform: translate(0,-100%);
}
.entryAnimation-enter-active {
    transition: all 1s ease;
}
.entryAnimation-leave-active {
    transition: all 1s ease;
}
.entryAnimation-leave-to {
    transform: translate(0,100%);
}
.app_img{
    position: fixed;
    left:0;
    top:0;
    right: 0;
    bottom:0;
    z-index: 999;
    width: 100%;
    height:100%;
    object-fit:cover;
}
</style>



// WEBPACK FOOTER //
// src/App.vue